import React, { useEffect } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import qtWebLog from "@qt-mobile/web-log";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { useState } from "react";
import { Fragment } from "react";
import Modal from "@qt-react/modal";
import "@qt-react/modal/dist/index.css";
import { useEffect as useEffect__6, useRef } from "react";
import axios from "axios";
import Toast from "@qt-react/toast";
import "@qt-react/toast/dist/index.css";
import { Component } from "react";
import Index from "@qt-member/draw";
import "@qt-member/draw/mdist/index.css";
import jscookie from "js-cookie";
import LotteryGrid from "@lib-common/lottery-grid";
import "@qt-mobile/web-linkedme";
import { useEffect as useEffect__34 } from "react";
import get from "lodash/get";
import { useEffect as useEffect__61 } from "react";
import { useEffect as useEffect__67 } from "react";
import { useEffect as useEffect__73 } from "react";
import { useEffect as useEffect__100 } from "react";
import { useRef as useRef__101, useState as useState__101, useEffect as useEffect__101 } from "react";
import { useEffect as useEffect__103 } from "react";
import { useEffect as useEffect__130 } from "react";
import { useRef as useRef__131, useState as useState__131, useEffect as useEffect__131 } from "react";
import { useEffect as useEffect__133 } from "react";
window.__BUILDER_PAGE_ID = '5ee23577ef25bb384335ff19';
const isInApp = qt.env.inApp;
window.qtWebLog = qtWebLog;

if (!isInApp) {
  qtWebLog.push('_setAccount', 'MobileSite');
} //格式化时间


const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = endTime => {
  const currentTime = new Date();

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = startTime => {
  const currentTime = new Date();

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime) => {
  let display = "block";

  if (endTime && isExpire(endTime) || startTime && isNotStart(startTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = ({
  basicConfig: basicConfig,
  containerConfig: containerConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  }; //微信分享

  if (wxShare.isInWeixin) {
    wxShare.setShareConfig(wxShareConfig);
  }

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    };

    qt.page.setNavbar({
      hideShare: basicConfig.isHiddenAppShare
    }); //设置页面分享
    // if (window.webkit
    //   && window.webkit.messageHandlers
    //   && window.webkit.messageHandlers.setWebviewConfig) {
    //     window.webkit.messageHandlers.setShareInfo.postMessage({
    //         shareHidden: 0
    //     });
    // }
    //
    // //app内部的分享

    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    const logData = {
      topic_id: window.__BUILDER_PAGE_ID,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id
      }
    };
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;

    if (isInApp) {
      qt.log.event({
        label: 'view',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'view', logData);
    }

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const {
    startTime,
    endTime,
    endTitle,
    beforeTitle,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = containerConfig;
  const isExpireShow = isExpire(endTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期~' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign(currentStyle, style);
  return display === 'block' ? <div className="" style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
        <div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
            <div style={{
        width: '6rem',
        margin: '0 auto'
      }}><img style={{
          width: '100%'
        }} alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} /></div>
            <div style={{
        fontSize: '0.85rem',
        color: '#333',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0.5rem'
      }}>{tip}</div>
        </div>
    </div>;
};

const transferTime = time => {
  if (!time) return null;
  return new Date(Date.parse(time.replace(/-/g, '/')));
};

const TimeController = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState(isDisplay); // == 实时更新开启以及当前时间在结束时间或者开始时间之前才开启

  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const CommonImage = ({
  config: config,
  sendLog: sendLog
}) => {
  const {
    openLazyload,
    openExpose
  } = config;
  const imgRef = React.useRef();
  const [measure, setMeasure] = React.useState();
  const [load, setLoad] = React.useState(false);
  const [exposed, setExposed] = React.useState(false);

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  React.useEffect(() => {
    if (!config.src) return;
    window.addEventListener("load", () => {
      const elem = imgRef.current;
      if (!elem) return;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = getScrollTop();
      const offsetTop = scrollTop + elem.getBoundingClientRect().top;
      const initMeasure = {
        offsetTop,
        windowHeight,
        load: scrollTop + windowHeight >= offsetTop
      };
      setMeasure(initMeasure);
    });
  }, []); // == 懒加载监听

  React.useEffect(() => {
    if (!openLazyload || !measure || measure.load || load) return;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const lazyloadListener = () => {
      const scrollTop = getScrollTop();
      const isLoad = scrollTop + windowHeight >= parseInt(offsetTop) - 30; // 提前30像素加载

      if (isLoad) setLoad(isLoad);
    };

    window.addEventListener('scroll', lazyloadListener);
    return () => {
      window.removeEventListener('scroll', lazyloadListener);
    };
  }, [measure, load]); // == 曝光监听

  React.useEffect(() => {
    if (!openExpose || !measure || exposed) return;
    const isImageLoad = !openLazyload || measure.load || load; // == 懒加载情况下，图片未加载不开启曝光监听

    if (!isImageLoad) return;
    let height = imgRef.current.getBoundingClientRect().height;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const exposeListener = () => {
      const scrollTop = getScrollTop();
      height = height > 0 ? height : imgRef.current.getBoundingClientRect().height; // == 图片50%露出才曝光

      const isExposeTop = scrollTop >= offsetTop + height / 2 - windowHeight;
      const isExposeBottom = scrollTop < offsetTop + height / 2;
      const isExpose = isExposeTop && isExposeBottom;
      if (!isExpose) return;
      sendLog('expose'); // 发送曝光打点

      setExposed(true); // == 10秒后再次开启曝光

      setTimeout(() => setExposed(false), 10000);
    };

    exposeListener();
    window.addEventListener('scroll', exposeListener);
    return () => {
      window.removeEventListener('scroll', exposeListener);
    };
  }, [measure, load, exposed]);
  return config.src ? openLazyload ? <img ref={imgRef} className={`block lh-100 ${measure && measure.load || load ? '' : 'invisible '}${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={measure && measure.load || load ? config.src : null} /> : <img ref={imgRef} className={`block lh-100 ${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={config.src} /> : <div className="text-center mv-3 f14">请添加图片</div>;
};

const SingleImage = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  config: config,
  containerStyle: containerStyle,
  children: children
}) => {
  const {
    origin,
    pathname,
    search
  } = window.location;
  const {
    link,
    linkInApp,
    linkOutApp,
    openNewWebview
  } = config;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink;
  const pageId = window.__BUILDER_PAGE_ID; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });
  return finalLink ? <a id={id} className="block" style={containerStyle} onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </a> : <div id={id} style={containerStyle}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </div>;
};

const wrapStyle = {
  fontSize: '14px',
  textAlign: 'center',
  vertAlign: 'middle',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const RenderRule = ({
  basicConfig: basicConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  let width = basicConfig.coverImgWidth,
      height = basicConfig.coverImgHeight,
      top = basicConfig.coverImgTop,
      right = basicConfig.coverImgRight,
      bottom = basicConfig.coverImgBottom,
      left = basicConfig.coverImgLeft,
      unit = basicConfig.unit;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let ruleStyle = Object.assign({}, wrapStyle, {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    position: basicConfig.position,
    zIndex: basicConfig.zIndex
  });

  if (basicConfig.position === 'fixed' || basicConfig.position === 'absolute') {
    ruleStyle = Object.assign({}, wrapStyle, {
      width,
      height,
      top,
      right,
      bottom,
      left,
      position: basicConfig.position,
      zIndex: basicConfig.zIndex
    });
  }

  const isInApp = qt.env.inApp;
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  const imgStyle = {
    width,
    height
  };
  const contentStyle = {
    lineHeight: basicConfig.lineHeight,
    whiteSpace: 'pre-wrap',
    height: basicConfig.ruleContentHeight ? basicConfig.ruleContentHeight + basicConfig.unit : '',
    maxHeight: basicConfig.ruleContentMaxHeight ? basicConfig.ruleContentMaxHeight + basicConfig.unit : '',
    textAlign: 'left',
    overflowY: 'auto',
    fontSize: basicConfig.ruleFontSize
  };
  return <Fragment>
        <div style={ruleStyle} onClick={() => {
      if (isInApp) {
        qt.log.event({
          label: 'click',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'click', logData);
      }

      Modal.show({
        title: '活动规则',
        jsxContent: <div style={contentStyle} dangerouslySetInnerHTML={{
          __html: basicConfig.ruleContent
        }}></div>,
        showTopPic: false,
        okText: '知道了',
        onOk: () => {},
        showCancel: false
      });
    }}>
            {children ? children : <img style={imgStyle} alt={"rule-cover"} src={basicConfig.coverImg} />}
        </div>
    </Fragment>;
};

const BaseLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景设置

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem' || style.type === '%') {
    const {
      type,
      top,
      bottom,
      left,
      right,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight
    } = style;
    style.top = top ? `${top}${type}` : top;
    style.bottom = bottom ? `${bottom}${type}` : bottom;
    style.left = left ? `${left}${type}` : left;
    style.right = right ? `${right}${type}` : right;
    style.marginTop = marginTop ? `${marginTop}${type}` : marginTop;
    style.marginBottom = marginBottom ? `${marginBottom}${type}` : marginBottom;
    style.marginLeft = marginLeft ? `${marginLeft}${type}` : marginLeft;
    style.marginRight = marginRight ? `${marginRight}${type}` : marginRight;
    style.paddingTop = paddingTop ? `${paddingTop}${type}` : paddingTop;
    style.paddingBottom = paddingBottom ? `${paddingBottom}${type}` : paddingBottom;
    style.paddingLeft = paddingLeft ? `${paddingLeft}${type}` : paddingLeft;
    style.paddingRight = paddingRight ? `${paddingRight}${type}` : paddingRight;
  }

  delete style.type;
  return children ? <div id={id} style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const productId = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const isBenefit = false;
const isAbsolute = false;
const popLog = true;
const unit = "px";
const position = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_e76a7b7c80b5c04dd757001ec3a8dc8f.png",
  bgColor: "transparent",
  width: 280,
  height: 45
};
const text = {
  content: "",
  color: "transparent",
  fontSize: 16
};
const hasAnimation = true;

const BuyButton = ({
  text: text,
  btnStyle: btnStyle,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = useRef(); // == 防止重复曝光打点

  const [exposed, setExposed] = React.useState(false);
  useEffect__6(() => {
    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);
  useEffect__6(() => {
    if (!popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const purchase = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'click.buyButton',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId.iosId
      };
    } else {
      param = {
        itemId: productId.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            },
            withCredentials: true
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'expose.buyButton',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle} onClick={() => purchase()} ref={buttonRef}>{text}</div>
  </div>;
};

window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);
window.qtWebLog = qtWebLog;
qtWebLog.push('_setAccount', 'MobileSite');

const MemberDraw = ({
  children: children,
  activity_id: activity_id,
  canSetShare: canSetShare,
  shareAddChance: shareAddChance,
  pageTitleCanModify: pageTitleCanModify,
  showTop: showTop,
  showBottom: showBottom,
  serviceUrl: serviceUrl,
  env: env,
  defaultStyle: defaultStyle,
  customeStyle: customeStyle,
  locationStyle: locationStyle,
  threeParty: threeParty,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId
}) => {
  // == 将请求的 url 地址挂载到 window
  window.__SERVICE_URL = serviceUrl;
  return <div id={id}>
            <Index activity_id={activity_id} canSetShare={canSetShare} shareAddChance={shareAddChance} pageTitleCanModify={pageTitleCanModify} showTop={showTop} showBottom={showBottom} env={env} defaultStyle={defaultStyle} customeStyle={customeStyle} locationStyle={locationStyle} threeParty={threeParty} logData={{
      topic_id: window.__BUILDER_PAGE_ID,
      nodeId,
      nodeType,
      id
    }}>
                {children}
            </Index>
        </div>;
};

const HorizontalLayout = ({
  id: id,
  config: config,
  children: children
}) => {
  const {
    wrap,
    horizontalCss,
    verticalCss,
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  delete commonStyle.background;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景处理

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div id={id} className={`flex${horizontalCss ? ' ' + horizontalCss : ''}${verticalCss ? ' ' + verticalCss : ''}${wrap ? ' flex-wrap' : ' '}`} style={style}>
      {children}
    </div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const wrapStyle__30 = {
  fontSize: '14px',
  textAlign: 'center',
  vertAlign: 'middle',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const RenderRule__30 = ({
  basicConfig: basicConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  let width = basicConfig.coverImgWidth,
      height = basicConfig.coverImgHeight,
      top = basicConfig.coverImgTop,
      right = basicConfig.coverImgRight,
      bottom = basicConfig.coverImgBottom,
      left = basicConfig.coverImgLeft,
      unit = basicConfig.unit;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let ruleStyle = Object.assign({}, wrapStyle__30, {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    position: basicConfig.position,
    zIndex: basicConfig.zIndex
  });

  if (basicConfig.position === 'fixed' || basicConfig.position === 'absolute') {
    ruleStyle = Object.assign({}, wrapStyle__30, {
      width,
      height,
      top,
      right,
      bottom,
      left,
      position: basicConfig.position,
      zIndex: basicConfig.zIndex
    });
  }

  const isInApp = qt.env.inApp;
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  const imgStyle = {
    width,
    height
  };
  const contentStyle = {
    lineHeight: basicConfig.lineHeight,
    whiteSpace: 'pre-wrap',
    height: basicConfig.ruleContentHeight ? basicConfig.ruleContentHeight + basicConfig.unit : '',
    maxHeight: basicConfig.ruleContentMaxHeight ? basicConfig.ruleContentMaxHeight + basicConfig.unit : '',
    textAlign: 'left',
    overflowY: 'auto',
    fontSize: basicConfig.ruleFontSize
  };
  return <Fragment>
        <div style={ruleStyle} onClick={() => {
      if (isInApp) {
        qt.log.event({
          label: 'click',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'click', logData);
      }

      Modal.show({
        title: '活动规则',
        jsxContent: <div style={contentStyle} dangerouslySetInnerHTML={{
          __html: basicConfig.ruleContent
        }}></div>,
        showTopPic: false,
        okText: '知道了',
        onOk: () => {},
        showCancel: false
      });
    }}>
            {children ? children : <img style={imgStyle} alt={"rule-cover"} src={basicConfig.coverImg} />}
        </div>
    </Fragment>;
};

const getTime = endTime => {
  if (!endTime) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const currentTime = new Date();
  const newEndTime = formatTime(endTime);
  const leftTime = new Date(newEndTime.valueOf() - currentTime.valueOf());
  const diff_time = leftTime / 1000;
  const days = parseInt(diff_time / 86400);
  const hours = parseInt(diff_time / 3600) - 24 * days;
  const minutes = parseInt(diff_time % 3600 / 60);
  const seconds = parseInt(diff_time % 60);
  return {
    days,
    hours,
    minutes,
    seconds
  };
};

const RenderCountDown = ({
  basicConfig: basicConfig
}) => {
  const expire = isExpire(basicConfig.endTime);
  let {
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    top,
    bottom,
    left,
    right,
    unit
  } = basicConfig;

  if (unit !== 'px') {
    paddingTop = paddingTop + unit;
    paddingBottom = paddingBottom + unit;
    paddingLeft = paddingLeft + unit;
    paddingRight = paddingRight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let style = {
    color: basicConfig.fontColor,
    background: basicConfig.bgColor,
    borderRadius: basicConfig.borderRadius,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    display: 'inline-block',
    fontWeight: basicConfig.fontWeight,
    fontSize: basicConfig.fontSize,
    position: basicConfig.position,
    marginTop: top,
    marginBottom: bottom,
    marginLeft: left,
    marginRight: right
  };

  if (basicConfig.position === 'absolute' || basicConfig.position === 'fixed') {
    style = {
      color: basicConfig.fontColor,
      background: basicConfig.bgColor,
      borderRadius: basicConfig.borderRadius,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      display: basicConfig.display,
      fontWeight: basicConfig.fontWeight,
      fontSize: basicConfig.fontSize,
      position: basicConfig.position,
      top,
      bottom,
      left,
      right
    };
  }

  const [leftTime, setLeftTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    if (!basicConfig.endTime) return;

    let timeOut = () => {
      const expire = isExpire(basicConfig.endTime);
      if (expire) return;
      setTimeout(() => {
        let time = getTime(basicConfig.endTime);
        setLeftTime(time);
        timeOut();
      }, 1000);
    };

    timeOut();
  }, []);
  return basicConfig.isCustomizeEndTitle && expire ? <div style={style}>
            <span>{basicConfig.customizeEndTitle}</span>
        </div> : <div style={style}>
        <span>{basicConfig.title}</span>
        <span>{leftTime.days}天</span>
        <span>{leftTime.hours}时</span>
        <span>{leftTime.minutes}分</span>
        <span>{leftTime.seconds}秒</span>
    </div>;
};

const productId__34 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__34 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__34 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_84ec3e8215f31d104120ef4147668fa1.png",
  bgColor: "transparent",
  width: 250,
  height: 40
};
const text__34 = {
  content: "",
  color: "red",
  fontSize: 16
};

const BuyButton__34 = ({
  text: text__34,
  btnStyle: btnStyle__34,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  useEffect__34(() => {
    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);
  useEffect__34(() => {
    if (!popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const purchase = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'click.buyButton',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__34.iosId
      };
    } else {
      param = {
        itemId: productId__34.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            },
            withCredentials: true
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'expose.buyButton',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__34} onClick={() => purchase()} ref={buttonRef}>{text__34}</div>
  </div>;
};

window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);
window.qtWebLog = qtWebLog;
qtWebLog.push('_setAccount', 'MobileSite');

const Button = (close = () => {}) => {
  return <div onClick={() => {
    close();
  }} style={{
    backgroundImage: 'linear-gradient(-135deg, #FF8A8A 0%, #FD5353 100%)',
    borderRadius: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    marginTop: '16px'
  }}>
        <div style={{
      height: '20px'
    }}><img style={{
        width: '20px'
      }} src={"https://sss.staging.qingting.fm/qt-builder-manage/upload_f233ad9be29cd0eb6ef09cf8d7e1cbef.png"} /></div>
        <div style={{
      color: '#fff',
      fontSize: '16px'
    }}>开启手机通知</div>
    </div>;
};

const RenderReserve = ({
  basicConfig: basicConfig,
  styleConfig: styleConfig,
  id: id,
  nodeId: nodeId,
  nodeType: nodeType
}) => {
  const [isReserved, setReserved] = useState(false); //获取用户信息

  const getUserInfo = async () => {
    try {
      let userId = await qt.getUserId();
      let res = (await qt.getDevice()) || '';
      const deviceId = res.deviceId;
      return {
        userId: userId || '',
        deviceId: deviceId
      };
    } catch (e) {
      return {
        userId: '',
        deviceId: ''
      };
    }
  };

  const host = basicConfig.isStaging ? 'https://ac.staging.qingting.fm/v1/user/appointment' : 'https://ac.qingting.fm/v1/user/appointment'; // 当前是否预约

  const getIsReserve = async () => {
    try {
      let {
        userId,
        deviceId
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',').join('&task_ids=');
      const res = await axios.get(`${host}?task_ids=${task}&device_id=${deviceId}&userId=${userId}`);
      const result = get(res, 'data.data');
      setReserved(result);
    } catch (e) {
      console.log(e);
    }
  };

  const isInApp = qt.env.inApp;
  let {
    imgWidth,
    imgHeight,
    top,
    bottom,
    left,
    right,
    unit,
    position,
    display,
    zIndex
  } = styleConfig;

  if (unit !== 'px') {
    imgWidth = imgWidth + unit;
    imgHeight = imgHeight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let wrapStyle = {
    width: imgWidth,
    height: imgHeight,
    display,
    marginTop: top,
    marginBottom: bottom,
    marginRight: right,
    marginLeft: left,
    overflow: 'hidden',
    position,
    zIndex
  };

  if (position === 'absolute' || position === 'fixed') {
    wrapStyle = {
      width: imgWidth,
      height: imgHeight,
      display,
      top,
      bottom,
      right,
      left,
      overflow: 'hidden',
      position,
      zIndex
    };
  }

  const imgStyle = {
    width: imgWidth,
    display: 'block'
  };

  const isOpen = async () => {
    try {
      const open = await qt.checkNotification({
        forceRequest: true
      });

      if (open) {
        Toast.info({
          content: '开启成功',
          duration: 3000,
          onClose: () => {}
        });
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
    type: 'live'
  }, null);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  }; //去设置按钮的log数据

  const btnLogData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    type: 'modal-btn',
    pos: {
      type: nodeType,
      name: id
    }
  }; //弹窗的曝光数据

  const modalLogData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    type: 'modal-notice',
    pos: {
      type: nodeType,
      name: id
    }
  };

  const closeModal = () => {
    if (isInApp) {
      qt.log.event({
        label: 'click',
        data: btnLogData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', btnLogData);
    }

    Modal.close();
    setTimeout(() => {
      return isOpen(); // return open(isOpen)
    }, 0);
  };

  useEffect(() => {
    if (isInApp) {
      qt.log.event({
        label: 'view',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'view', logData);
    }

    if (isInApp) {
      getIsReserve();
    }

    return () => {
      localStorage.removeItem('global_reserve_back');
    };
  }, []); //检查是否开通通知权限

  const checkNotificationPermission = async data => {
    // const newData = JSON.parse(data)
    // const code = newData.code
    try {
      const isOpen = await qt.checkNotification({
        forceRequest: false
      });

      if (!isOpen) {
        if (basicConfig.pushType) {
          if (isInApp) {
            qt.log.event({
              label: 'view',
              data: modalLogData
            });
          } else {
            qtWebLog.push('_trackEvent', 'view', modalLogData);
          }

          Modal.show({
            title: '开启通知',
            subTitle: basicConfig.modalMessage || '开启后第一时间收听上新音频',
            bottomTip: '',
            showTopPic: true,
            okText: '提交',
            onOk: () => {},
            footer: Button(closeModal),
            showCancel: true,
            cancelText: '关闭',
            showCloseIcon: true,
            topImg: 'https://sss.staging.qingting.fm/qt-builder-manage/upload_1f7e5407b843ed6c871d629a44079a38.png',
            onCancel: () => {}
          });
        }
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  const isShowReserve = !isExpire(basicConfig.endTime) && !isNotStart(basicConfig.startTime);
  const imgUrl = isReserved ? basicConfig.reservedImg : basicConfig.unReserveImg;

  const gotoReserve = async () => {
    try {
      let {
        userId,
        deviceId = ''
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',');
      const numberTaskIds = task.map(Number);
      const response = await axios.put(`${host}`, {
        user_id: userId,
        device_id: deviceId,
        task_ids: numberTaskIds
      }); //判断通知权限有木有，并且是不是需要开启预约权限

      const errorCode = get(response, 'data.errcode', '');
      const errmsg = get(response, 'data.errmsg', '预约失败');

      if (errorCode === 0) {
        setReserved(true);
        setTimeout(() => {
          return checkNotificationPermission(); // return check(checkNotificationPermission)
        }, 0);
      } else {
        Toast.info({
          content: errmsg,
          duration: 3000,
          onClose: () => {}
        });
      }
    } catch (e) {
      Toast.info({
        content: '接口请求失败，请稍后重试',
        duration: 3000,
        onClose: () => {}
      });
    }
  };

  return isShowReserve ? <div onClick={async () => {
    if (isInApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    } // 已预约，则不能点击


    if (isReserved) return;

    if (isInApp) {
      let {
        userId
      } = await getUserInfo();

      if (basicConfig.isNeedLogin && !userId) {
        qt.login({
          success: () => {
            return gotoReserve();
          }
        });
      } else {
        return gotoReserve();
      }
    } else {
      window.linkedme.generate({
        type: 'h5',
        h5Url: window.location.href
      }).then(res => {
        window.linkedme.trigger(res.url);
      });
    }
  }} style={wrapStyle} id={id}>
        <img style={imgStyle} src={imgUrl} alt="reserve" />
    </div> : null;
};

const code = "713847746467098";
const couponImg = "https://sss.qingting.fm/qt-builder-manage/upload_1d91b4531448d8d12cdb81635897df72.jpg";
const hasReceiveImg = "https://sss.qingting.fm/qt-builder-manage/upload_f0868bc42f64d3733b94ef632f8f425f.jpg";
const limit = 1;
const couponStyle = {
  absolute: false,
  top: null,
  left: null,
  right: null,
  bottom: null,
  widthStyle: "percentage",
  width: 100
};

const Coupon = ({
  imgSrc: imgSrc,
  hasReceiveImg: hasReceiveImg,
  style: style,
  useCode: useCode,
  limitNum: limitNum
}) => {
  const [userId, setUserId] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [hasReceived, setHasReceived] = useState(false);
  let apiBlock = false;
  useEffect__61(() => {
    qt.getUserId().then(id => setUserId(id));

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const receive = () => {
    if (apiBlock) return;
    if (hasReceived) return;

    if (userId) {
      let userMsg = JSON.parse(localStorage.getItem(userId) || "{}");

      if (userMsg.exchangeCount !== undefined && userMsg.exchangeCount >= limitNum) {
        setHasReceived(true);
        Toast.info({
          content: '已达领取上限',
          duration: 2000
        });
        return;
      }

      axios.get('https://webapi.qingting.fm/material/frontend/423/exchange-coupon', {
        params: {
          user_id: userId,
          use_code: useCode,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      }).then(data => {
        apiBlock = false;

        if (data && data.data && data.data.errorno === 0) {
          userMsg.exchangeCount = userMsg.exchangeCount + 1 || 1;
          if (userMsg.exchangeCount >= limitNum) setHasReceived(true);
          localStorage.setItem(userId, JSON.stringify(userMsg));
          Toast.info({
            content: '领取成功',
            duration: 2000
          });
        } else if (data && data.data && data.data.errorno === 50001) {
          Toast.info({
            content: '系统繁忙, 请稍后再试',
            duration: 2000
          });
        } else {
          if (data && data.data && data.data.errorno === 43005 || data.data.errorno === 43006) {
            setHasReceived(true);
          }

          Toast.info({
            content: data && data.data && data.data.errormsg || '领取失败',
            duration: 2000
          });
        }
      }).finally(() => apiBlock = false);
    } else {
      qt.login();
    }
  };

  return imgSrc ? <img src={hasReceived ? hasReceiveImg : imgSrc} style={style} onClick={() => receive()} alt='' /> : <div>请上传图片</div>;
};

const couponImg__67 = "https://sss.qingting.fm/qt-builder-manage/upload_389cf71de03f954aef41278a40d6efe0.jpg";
const hasReceiveImg__67 = "https://sss.qingting.fm/qt-builder-manage/upload_398a352e2ab09f6e3e2c3c4c0e21c01f.jpg";
const limit__67 = 3;
const couponStyle__67 = {
  absolute: false,
  top: null,
  left: null,
  right: null,
  bottom: null,
  widthStyle: "percentage",
  width: 100
};

const Coupon__67 = ({
  imgSrc: imgSrc,
  hasReceiveImg: hasReceiveImg__67,
  style: style,
  useCode: useCode,
  limitNum: limitNum
}) => {
  const [userId, setUserId] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [hasReceived, setHasReceived] = useState(false);
  let apiBlock = false;
  useEffect__67(() => {
    qt.getUserId().then(id => setUserId(id));

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const receive = () => {
    if (apiBlock) return;
    if (hasReceived) return;

    if (userId) {
      let userMsg = JSON.parse(localStorage.getItem(userId) || "{}");

      if (userMsg.exchangeCount !== undefined && userMsg.exchangeCount >= limitNum) {
        setHasReceived(true);
        Toast.info({
          content: '已达领取上限',
          duration: 2000
        });
        return;
      }

      axios.get('https://webapi.qingting.fm/material/frontend/423/exchange-coupon', {
        params: {
          user_id: userId,
          use_code: useCode,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      }).then(data => {
        apiBlock = false;

        if (data && data.data && data.data.errorno === 0) {
          userMsg.exchangeCount = userMsg.exchangeCount + 1 || 1;
          if (userMsg.exchangeCount >= limitNum) setHasReceived(true);
          localStorage.setItem(userId, JSON.stringify(userMsg));
          Toast.info({
            content: '领取成功',
            duration: 2000
          });
        } else if (data && data.data && data.data.errorno === 50001) {
          Toast.info({
            content: '系统繁忙, 请稍后再试',
            duration: 2000
          });
        } else {
          if (data && data.data && data.data.errorno === 43005 || data.data.errorno === 43006) {
            setHasReceived(true);
          }

          Toast.info({
            content: data && data.data && data.data.errormsg || '领取失败',
            duration: 2000
          });
        }
      }).finally(() => apiBlock = false);
    } else {
      qt.login();
    }
  };

  return imgSrc ? <img src={hasReceived ? hasReceiveImg__67 : imgSrc} style={style} onClick={() => receive()} alt='' /> : <div>请上传图片</div>;
};

const couponImg__73 = "https://sss.qingting.fm/qt-builder-manage/upload_77819e76625b6f8d74b51d540c5a358a.jpg";
const hasReceiveImg__73 = "https://sss.qingting.fm/qt-builder-manage/upload_803b91818cb2742b0fe80a1be1b872d5.jpg";
const limit__73 = 3;
const couponStyle__73 = {
  absolute: false,
  top: null,
  left: null,
  right: null,
  bottom: null,
  widthStyle: "percentage",
  width: 100
};

const Coupon__73 = ({
  imgSrc: imgSrc,
  hasReceiveImg: hasReceiveImg__73,
  style: style,
  useCode: useCode,
  limitNum: limitNum
}) => {
  const [userId, setUserId] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [hasReceived, setHasReceived] = useState(false);
  let apiBlock = false;
  useEffect__73(() => {
    qt.getUserId().then(id => setUserId(id));

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const receive = () => {
    if (apiBlock) return;
    if (hasReceived) return;

    if (userId) {
      let userMsg = JSON.parse(localStorage.getItem(userId) || "{}");

      if (userMsg.exchangeCount !== undefined && userMsg.exchangeCount >= limitNum) {
        setHasReceived(true);
        Toast.info({
          content: '已达领取上限',
          duration: 2000
        });
        return;
      }

      axios.get('https://webapi.qingting.fm/material/frontend/423/exchange-coupon', {
        params: {
          user_id: userId,
          use_code: useCode,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      }).then(data => {
        apiBlock = false;

        if (data && data.data && data.data.errorno === 0) {
          userMsg.exchangeCount = userMsg.exchangeCount + 1 || 1;
          if (userMsg.exchangeCount >= limitNum) setHasReceived(true);
          localStorage.setItem(userId, JSON.stringify(userMsg));
          Toast.info({
            content: '领取成功',
            duration: 2000
          });
        } else if (data && data.data && data.data.errorno === 50001) {
          Toast.info({
            content: '系统繁忙, 请稍后再试',
            duration: 2000
          });
        } else {
          if (data && data.data && data.data.errorno === 43005 || data.data.errorno === 43006) {
            setHasReceived(true);
          }

          Toast.info({
            content: data && data.data && data.data.errormsg || '领取失败',
            duration: 2000
          });
        }
      }).finally(() => apiBlock = false);
    } else {
      qt.login();
    }
  };

  return imgSrc ? <img src={hasReceived ? hasReceiveImg__73 : imgSrc} style={style} onClick={() => receive()} alt='' /> : <div>请上传图片</div>;
};

const SpaceLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    common,
    styles
  } = config;
  const {
    height,
    cloneElementId
  } = common;
  const {
    background,
    position,
    top
  } = styles;
  const [elemHeight, setElemHeight] = useState(height); // == 获取元素高度

  useEffect__100(() => {
    if (!cloneElementId) return;
    const elem = document.getElementById(cloneElementId);
    if (!elem) return;

    const updateHeight = () => {
      const dynamicHeight = elem.getBoundingClientRect().height;
      if (dynamicHeight > 0 && elemHeight !== dynamicHeight) setElemHeight(dynamicHeight);
    };

    if (elem.tagName === 'IMG') {
      elem.complete ? updateHeight() : elem.onload = () => {
        updateHeight();
      };
    } else {
      const imgElems = elem.querySelectorAll('img');
      if (!imgElems.length) return updateHeight();

      for (let i = 0, n = imgElems.length; i < n; i++) {
        const imgElem = imgElems[i];
        imgElem.complete ? updateHeight() : imgElem.onload = () => {
          updateHeight();
        };
      }
    }
  }, []); // == 设置样式

  const style = {
    position,
    top,
    height: elemHeight
  };
  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color;
  return <div id={id} style={style}>{children || null}</div>;
};

const position__101 = "bottom";
const effects = "scrollUpShow";
const effectParam = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const customStyle = {
  width: 82,
  height: 14,
  aspectRatio: "82:14",
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_1cb463692aa9ba3795776bd99ea37b80.png",
  bgColor: "transparent",
  top: 100,
  zIndex: 100,
  hasGradient: false,
  gradientDeg: 90,
  bgColor2: "transparent"
};

const FixedBar = ({
  children: children,
  position: position__101,
  customStyle: customStyle,
  effects: effects,
  effectParam: effectParam
}) => {
  const fixBar = useRef__101();
  const [fixStyle, setFixStyle] = useState__101({});
  useEffect__101(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle.aspectRatio) {
      const radios = customStyle.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position__101) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__103 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const popLog__103 = false;
const position__103 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__103 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_c45b70625c31e79c128fea93e0a31f7a.png",
  bgColor: "transparent",
  width: 120,
  height: 35
};
const text__103 = {
  content: "",
  color: "red",
  fontSize: 16
};

const BuyButton__103 = ({
  text: text__103,
  btnStyle: btnStyle__103,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog__103
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  useEffect__103(() => {
    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);
  useEffect__103(() => {
    if (!popLog__103) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const purchase = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'click.buyButton',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__103.iosId
      };
    } else {
      param = {
        itemId: productId__103.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            },
            withCredentials: true
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'expose.buyButton',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__103} onClick={() => purchase()} ref={buttonRef}>{text__103}</div>
  </div>;
};

const SpaceLayout__130 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    common,
    styles
  } = config;
  const {
    height,
    cloneElementId
  } = common;
  const {
    background,
    position,
    top
  } = styles;
  const [elemHeight, setElemHeight] = useState(height);
  useEffect__130(() => {
    if (!cloneElementId) return;
    const elem = document.getElementById(cloneElementId);
    if (!elem) return;

    const updateHeight = () => {
      const dynamicHeight = elem.getBoundingClientRect().height;
      if (dynamicHeight > 0 && elemHeight !== dynamicHeight) setElemHeight(dynamicHeight);
    };

    if (elem.tagName === 'IMG') {
      elem.complete ? updateHeight() : elem.onload = () => {
        updateHeight();
      };
    } else {
      const imgElems = elem.querySelectorAll('img');
      if (!imgElems.length) return updateHeight();

      for (let i = 0, n = imgElems.length; i < n; i++) {
        const imgElem = imgElems[i];
        imgElem.complete ? updateHeight() : imgElem.onload = () => {
          updateHeight();
        };
      }
    }
  }, []);
  const style = {
    position,
    top,
    height: elemHeight
  };
  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color;
  return <div id={id} style={style}>{children || null}</div>;
};

const position__131 = "bottom";
const effectParam__131 = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const customStyle__131 = {
  width: 82,
  height: 14,
  aspectRatio: "82:14",
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_dcd43181eb86bbde0ff5f1a6d0167d21.png",
  bgColor: "transparent",
  top: 100,
  zIndex: 100,
  hasGradient: false,
  gradientDeg: 90,
  bgColor2: "transparent"
};

const FixedBar__131 = ({
  children: children,
  position: position__131,
  customStyle: customStyle__131,
  effects: effects,
  effectParam: effectParam__131
}) => {
  const fixBar = useRef__131();
  const [fixStyle, setFixStyle] = useState__131({});
  useEffect__131(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle__131.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle__131.aspectRatio) {
      const radios = customStyle__131.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position__131) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle__131);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle__131);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle__131);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle__131);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__131[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__131[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__133 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__133 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__133 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_86a0fb4d3cedb1d841ea275a1fb43ae0.png",
  bgColor: "transparent",
  width: 120,
  height: 35
};
const text__133 = {
  content: "",
  color: "red",
  fontSize: 16
};

const BuyButton__133 = ({
  text: text__133,
  btnStyle: btnStyle__133,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  useEffect__133(() => {
    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);
  useEffect__133(() => {
    if (!popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const purchase = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'click.buyButton',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__133.iosId
      };
    } else {
      param = {
        itemId: productId__133.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            },
            withCredentials: true
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'expose.buyButton',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__133} onClick={() => purchase()} ref={buttonRef}>{text__133}</div>
  </div>;
};

export default (({}) => {
  const basicConfig = {
    title: "618年中大促",
    shareTitle: "618年中大促",
    shareImg: "https://sss.qingting.fm/qt-builder-manage/upload_cc7c1eae58e3890dd71fffd77a384d58.jpg",
    shareSubTitle: "买蜻蜓年卡，送京东plus年卡+芒果tv年卡",
    shareLink: "",
    isHiddenAppShare: false
  };
  const containerConfig = {
    startTime: "2020-06-18 00:06:09",
    endTime: "2020-06-19 00:00:00",
    bgc: "#ee474f",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "",
    margin: ""
  };
  const timeController = {
    startTime: "2020-06-12 17:02:12",
    endTime: "2020-06-17 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b8fd585d47be8ef3fd4235a0efc65888.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__3 = {
    position: "absolute",
    coverImg: "https://sss.qingting.fm/qt-builder-manage/upload_a61241cc4c78e04483d9c0bcc74eb759.png",
    unit: "px",
    coverImgWidth: 60,
    coverImgHeight: null,
    coverImgTop: 6,
    coverImgRight: 0,
    coverImgBottom: null,
    coverImgLeft: null,
    zIndex: "9",
    ruleContent: "<p>一、活动时间：2020年6月15日-2020年6月21日</p><p>二、活动特惠：在本活动页开通或续购价值228元的蜻蜓FM超级会员年卡，可享受4.5折购买年卡，价格98元/年。</p><p>三、抽奖规则：</p><p>1、抽奖时间为2020年6月18日 00:00-2020年6月19日 24:00</p><p>2、抽奖机会：</p><p><span style=\"color: rgb(51, 51, 51);\">①</span>抽奖活动期间，凡是当前有效会员，即可在本活动页享有1次抽奖机会；</p><p><span style=\"color: rgb(51, 51, 51);\">②</span>若在2020年6月15日 00:00-2020年6月19日 24:00期间，在活动页购买超级会员年卡，可新增3次抽奖机会，多买多得；</p><p><span style=\"color: rgb(51, 51, 51);\">③</span>在活动页“福利任务”版块，参与“618手速节”，购买任一专辑可增加1次抽奖机会，最多3次；</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;④</span>在活动页“福利任务”版块，收听9个专辑中任1/N个满120分钟可增加1次抽奖机会，最多1次；</p><p>3、奖品将在活动结束后30个工作日内发放。若用户存在刷奖等故意或者恶意违规的行为，一经核实，将取消中奖资格。</p><p>4、中奖所产生的偶然所得税等相关税金将由用户个人自行承担，根据国家税务局规定，蜻蜓FM将为中奖用户代扣代缴相关税金，若您是此次活动的中奖用户，请务必提供真实的姓名和身份证号、手机号，该身份信息只用于为您提供税务处理，如无法提供相关信息，或经个税系统验证不通过的，则视为自动放弃领奖资格。</p><p>四、关于赠品：</p><p>1.京东：</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;①</span>下单账户绑定的手机号若未注册过京东账户，须遵循京东PLUS会员的开通条件进行用户注册及实名认证。</p><p><span style=\"color: rgb(51, 51, 51);\">②&nbsp;</span>另因合作方要求，同一京东账号在蜻蜓FM仅可充值共2次京东PLUS会员。</p><p><span style=\"color: rgb(51, 51, 51);\">③</span>京东PLUS年卡指京东PLUS京典卡，不包含爱奇艺、腾讯等异业权益，京东PLUS年卡所含权益及规则以京东官方公布为准；</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;④</span>本次活动暂不支持海外手机号领取京东PLUS会员权益。且由于京东PLUS会员开通有综合评分要求，因此可能存在极少异常账号无法开通成功的情况，具体可咨询京东客服。</p><p>2.芒果本页面所赠送的芒果TV年卡仅适用于手机+iPad+电脑</p><p>3.因活动阶段不同及赠品方的合作要求，赠品可能发生变动，具体赠品以购买时页面的赠送信息为准，请核对后进行购买；用户主动领取赠品时，可能会出现少数充值到账延迟现象，会在7个工作日内完成到账。</p><p><br></p><p>有关本活动的最终解释权归蜻蜓FM所有，如有其它相关问题，也可拨打客服电话400-6992-927进行咨询。</p>",
    ruleContentHeight: 200,
    ruleContentMaxHeight: 300,
    ruleFontSize: 13,
    lineHeight: "1.5"
  };
  const singleImage__4 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_33817c95da277e12d496241ddee8c0de.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__4 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: 3.8,
      bottom: null,
      left: 1,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style = {
    backgroundImage: `url(${btnStyle.bgImg})`,
    backgroundColor: btnStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text.color,
    fontSize: text.fontSize + unit,
    margin: '0 auto',
    width: btnStyle.width + unit,
    height: btnStyle.height + unit,
    lineHeight: btnStyle.height + unit,
    borderRadius: btnStyle.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle = {
    top: position.top + unit,
    left: position.left + unit,
    right: position.right + unit,
    bottom: position.bottom + unit
  };
  const reStyle = {
    marginTop: position.top + unit,
    marginBottom: position.bottom + unit,
    marginLeft: position.left + unit,
    marginRight: position.right + unit
  };
  const singleImage__7 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b722945c6399a1343de2ae7b0bfdb102.jpg",
    link: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__7 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__8 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_0ea62376cf2e75de627f03974619ea1c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__8 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__9 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_d00a009abb0f48a165a2c4ebe54adc3a.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__9 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__10 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b604bb358ce09b2815115b979791e570.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__10 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const config = {
    activity_id: 1015,
    canSetShare: false,
    shareAddChance: false,
    pageTitleCanModify: false,
    showTop: false,
    showBottom: false,
    serviceUrl: "",
    defaultStyle: {
      pageBg: "",
      topImg: "",
      bottomImg: "",
      drawBackImg: "",
      prizeBorderColor: "",
      prizeNameColor: "",
      prizeDefaultColor: "",
      prizeSelectColor: "",
      drawBtnImg: "",
      ruleImg: "",
      myPrizeImg: ""
    },
    customeStyle: {
      prizeDefaultImg: "",
      prizeSelectImg: "",
      replaceCarousel: ""
    },
    locationStyle: {
      top: 0,
      bottom: 0,
      spacing: 24,
      type: "px"
    }
  };
  const singleImage__12 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_cc0377e5847b283cbad1ded59830631d.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__12 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__13 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_18ae7c39e6b1832baa5835ea25c70732.jpg",
    link: "",
    linkInApp: "https://sss.qingting.fm/topic/5ece1e34720cd66794d9b559/index.html?source=topic_supervip_activity_0618",
    linkOutApp: "https://sss.qingting.fm/topic/5ece1e34720cd66794d9b559/index.html?source=topic_supervip_activity_0618",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__13 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__14 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_14244ba9d518a5ce22f896f8e8224b6f.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__14 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__16 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_13bf4756f30ebdd60748abf341b596fe.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/345534",
    linkOutApp: "https://m.qingting.fm/vchannels/345534",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__16 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__17 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_aac24ec11db23ed20764a2c12e7ca245.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/102974",
    linkOutApp: "https://m.qingting.fm/vchannels/102974",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__17 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__18 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_0b1a533b8a9e6a87f223d765524fa63e.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294280",
    linkOutApp: "https://m.qingting.fm/vchannels/294280",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__18 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__19 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__20 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_31349c146809f88f48b6413cc4f26652.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/304214",
    linkOutApp: "https://m.qingting.fm/vchannels/304214",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__20 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__21 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_e0433028efed714391d9c172457141c6.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/47572",
    linkOutApp: "https://m.qingting.fm/vchannels/47572",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__21 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__22 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c7ee9bfc1058aec22f1806e0bea52986.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/271526",
    linkOutApp: "https://m.qingting.fm/vchannels/271526",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__22 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__23 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__24 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_94103145dca2c07f5bfbc2ca9997ca7d.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/266743",
    linkOutApp: "https://m.qingting.fm/vchannels/266743",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__24 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__25 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_5bc7487d38ceff167b2ea69ab1f60f66.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/293411",
    linkOutApp: "https://m.qingting.fm/vchannels/293411",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__25 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__26 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1cf86f1fe43a8d87745036398b90d9e6.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/275733",
    linkOutApp: "https://m.qingting.fm/vchannels/275733",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__26 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__27 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c2aa848fe5b36c26853cfdfd0ed20de5.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__27 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__28 = {
    startTime: "2020-06-18 00:00:00",
    endTime: "2020-06-18 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__29 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1bf5427445245b7057f9e09dcabd0862.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__29 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__30 = {
    position: "absolute",
    coverImg: "https://sss.qingting.fm/qt-builder-manage/upload_553ca148fedc5051ce70d3cc6003fdf1.png",
    unit: "px",
    coverImgWidth: 60,
    coverImgHeight: null,
    coverImgTop: 6,
    coverImgRight: 0,
    coverImgBottom: null,
    coverImgLeft: null,
    zIndex: "9",
    ruleContent: "<p>一、活动时间：2020年6月15日-2020年6月21日</p><p>二、活动特惠：在本活动页开通或续购价值228元的蜻蜓FM超级会员年卡，可享受4.5折购买年卡，价格98元/年。</p><p>三、抽奖规则：</p><p>1、抽奖时间为2020年6月18日 00:00-2020年6月19日 24:00</p><p>2、抽奖机会：</p><p><span style=\"color: rgb(51, 51, 51);\">①</span>抽奖活动期间，凡是当前有效会员，即可在本活动页享有1次抽奖机会；</p><p><span style=\"color: rgb(51, 51, 51);\">②</span>若在2020年6月18日 00:00-2020年6月19日 24:00期间，在活动页购买超级会员年卡，可新增3次抽奖机会，多买多得；</p><p><span style=\"color: rgb(51, 51, 51);\">③</span>在活动页“福利任务”版块，参与“618手速节”，购买任一专辑可增加1次抽奖机会，最多3次；</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;④</span>在活动页“福利任务”版块，收听9个专辑中任1/N个满120分钟可增加1次抽奖机会，最多1次；</p><p>3、奖品将在活动结束后30个工作日内发放。若用户存在刷奖等故意或者恶意违规的行为，一经核实，将取消中奖资格。</p><p>4、中奖所产生的偶然所得税等相关税金将由用户个人自行承担，根据国家税务局规定，蜻蜓FM将为中奖用户代扣代缴相关税金，若您是此次活动的中奖用户，请务必提供真实的姓名和身份证号、手机号，该身份信息只用于为您提供税务处理，如无法提供相关信息，或经个税系统验证不通过的，则视为自动放弃领奖资格。</p><p>四、关于赠品：</p><p>1.京东：</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;①</span>下单账户绑定的手机号若未注册过京东账户，须遵循京东PLUS会员的开通条件进行用户注册及实名认证。</p><p><span style=\"color: rgb(51, 51, 51);\">②&nbsp;</span>另因合作方要求，同一京东账号在蜻蜓FM仅可充值共2次京东PLUS会员。</p><p><span style=\"color: rgb(51, 51, 51);\">③</span>京东PLUS年卡指京东PLUS京典卡，不包含爱奇艺、腾讯等异业权益，京东PLUS年卡所含权益及规则以京东官方公布为准；</p><p><span style=\"color: rgb(51, 51, 51);\">&nbsp;④</span>本次活动暂不支持海外手机号领取京东PLUS会员权益。且由于京东PLUS会员开通有综合评分要求，因此可能存在极少异常账号无法开通成功的情况，具体可咨询京东客服。</p><p>2.芒果本页面所赠送的芒果TV年卡仅适用于手机+iPad+电脑</p><p>3.因活动阶段不同及赠品方的合作要求，赠品可能发生变动，具体赠品以购买时页面的赠送信息为准，请核对后进行购买；用户主动领取赠品时，可能会出现少数充值到账延迟现象，会在7个工作日内完成到账。</p><p><br></p><p>有关本活动的最终解释权归蜻蜓FM所有，如有其它相关问题，也可拨打客服电话400-6992-927进行咨询。</p>",
    ruleContentHeight: 200,
    ruleContentMaxHeight: 300,
    ruleFontSize: 13,
    lineHeight: "1.5"
  };
  const singleImage__31 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_d5746b08332e439e7e6dd7832d2cf7fd.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__31 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__32 = {
    endTime: "2020-06-19 00:00:00",
    title: "距结束：",
    isCustomizeEndTitle: false,
    customizeEndTitle: "活动结束啦",
    fontColor: "#000000",
    bgColor: "transparent",
    borderRadius: "",
    unit: "rem",
    paddingTop: null,
    paddingBottom: "",
    paddingRight: null,
    paddingLeft: null,
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: 0.2,
    bottom: "",
    left: 0.4,
    right: "",
    display: "inline-block"
  };
  const baseLayoutConfig__33 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: 4,
      bottom: null,
      left: 1.3,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__34 = {
    backgroundImage: `url(${btnStyle__34.bgImg})`,
    backgroundColor: btnStyle__34.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__34.color,
    fontSize: text__34.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__34.width + unit,
    height: btnStyle__34.height + unit,
    lineHeight: btnStyle__34.height + unit,
    borderRadius: btnStyle__34.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__34 = {
    top: position__34.top + unit,
    left: position__34.left + unit,
    right: position__34.right + unit,
    bottom: position__34.bottom + unit
  };
  const reStyle__34 = {
    marginTop: position__34.top + unit,
    marginBottom: position__34.bottom + unit,
    marginLeft: position__34.left + unit,
    marginRight: position__34.right + unit
  };
  const singleImage__35 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_776f63d15f26e82e71462dc1b068dded.jpg",
    link: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__35 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__36 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_f57d13cd95469de4d4e4b3bb8e813381.jpg",
    link: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__36 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__37 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_9d772751dd0fb65a3f9ba957d094d0ec.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__37 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__38 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_276d6f175ceed8a486aa5cf8a8e683d8.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__38 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__39 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_cc3ccfcb9a1427cb52e53e13b8b4536c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__39 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const config__40 = {
    activity_id: 1015,
    canSetShare: false,
    shareAddChance: false,
    pageTitleCanModify: false,
    showTop: false,
    showBottom: false,
    serviceUrl: "",
    defaultStyle: {
      pageBg: "",
      topImg: "",
      bottomImg: "",
      drawBackImg: "",
      prizeBorderColor: "",
      prizeNameColor: "",
      prizeDefaultColor: "",
      prizeSelectColor: "",
      drawBtnImg: "",
      ruleImg: "",
      myPrizeImg: ""
    },
    customeStyle: {
      prizeDefaultImg: "",
      prizeSelectImg: "",
      replaceCarousel: ""
    },
    locationStyle: {
      top: 0,
      bottom: 0,
      spacing: 24,
      type: "px"
    }
  };
  const singleImage__41 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_29c5a3d485eb00b8b6fcce198bb15f31.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__41 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__42 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b3e0764d69383264f55f04c49e3ad32e.jpg",
    link: "",
    linkInApp: "https://sss.qingting.fm/topic/5ece1e34720cd66794d9b559/index.html?source=topic_supervip_activity_0618",
    linkOutApp: "https://sss.qingting.fm/topic/5ece1e34720cd66794d9b559/index.html?source=topic_supervip_activity_0618",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__42 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__43 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_93b6945e3e28957f7bb74112836beda1.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__43 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__44 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__45 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c7d5752c48fbce117ff6a5815867515f.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/345534",
    linkOutApp: "https://m.qingting.fm/vchannels/345534",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__45 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__46 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_18372d3dbe6abe4c9d087dbd9753208d.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/102974",
    linkOutApp: "https://m.qingting.fm/vchannels/102974",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__46 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__47 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_ecf4859839aef2d4472ad681321c9544.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294280",
    linkOutApp: "https://m.qingting.fm/vchannels/294280",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__47 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__48 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__49 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_2b21075706274f260b392f03bcfae45a.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/304214",
    linkOutApp: "https://m.qingting.fm/vchannels/304214",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__49 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__50 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_225994052ae88d7222a95d8c8ce7a639.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/47572",
    linkOutApp: "https://m.qingting.fm/vchannels/47572",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__50 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__51 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_89622cb2e99d31f8ba99362163c83414.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/271526",
    linkOutApp: "https://m.qingting.fm/vchannels/271526",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__51 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__52 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__53 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_887c47cc9d0e26ed9458122d6e51cff1.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/266743",
    linkOutApp: "https://m.qingting.fm/vchannels/266743",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__53 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__54 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_a3c290d434e5b841118230673532f6ec.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/293411",
    linkOutApp: "https://m.qingting.fm/vchannels/293411",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__54 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__55 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_7c121a44aa571f9de086b06f9f61f12f.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/275733",
    linkOutApp: "https://m.qingting.fm/vchannels/275733",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__55 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__56 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c29db5fe17bf9dd44c95917072ce9716.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__56 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__57 = {
    pushType: "appPush",
    taskIds: "76,77,78,79,80",
    modalMessage: "开启后，可收到通知信息",
    isNeedLogin: true,
    startTime: "2020-06-12 14:59:54",
    endTime: "2020-06-19 11:59:59",
    unReserveImg: "https://sss.qingting.fm/qt-builder-manage/upload_d0a818a646a2db19e9c262a081fb0858.jpg",
    reservedImg: "https://sss.qingting.fm/qt-builder-manage/upload_26b56a41e0073d6fbd342eda35a6be25.jpg",
    isStaging: false
  };
  const styleConfig = {
    unit: "%",
    imgWidth: 100,
    imgHeight: "",
    top: "",
    bottom: "",
    left: "",
    right: "",
    display: "block",
    position: "relative",
    zIndex: 0
  };
  const timeController__58 = {
    startTime: "2020-06-17 00:00:00",
    endTime: "2020-06-17 11:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__59 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_56ca03f505f56f45d977632d5437f8ab.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__59 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__60 = {
    startTime: "2020-06-17 12:00:00",
    endTime: "2020-06-17 12:05:00",
    dynamic: true,
    duration: 10
  };
  const style__61 = {
    display: 'block',
    width: couponStyle.widthStyle === 'percentage' ? couponStyle.width + '%' : couponStyle.width,
    position: couponStyle.absolute ? 'absolute' : 'relative'
  };

  if (couponStyle.absolute) {
    Object.assign(style__61, {
      top: couponStyle.top,
      left: couponStyle.left,
      right: couponStyle.right,
      bottom: couponStyle.bottom
    });
  } else {
    Object.assign(style__61, {
      marginTop: couponStyle.top,
      marginLeft: couponStyle.left,
      marginRight: couponStyle.right,
      marginBottom: couponStyle.bottom
    });
  }

  const timeController__62 = {
    startTime: "2020-06-17 12:05:01",
    endTime: "2020-06-17 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__63 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_5797e51b78d1668010675be3bf67dbfb.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__63 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__64 = {
    startTime: "2020-06-18 00:00:00",
    endTime: "2020-06-18 11:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__65 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c39471629dd039a8fca72eb27f85add2.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__65 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__66 = {
    startTime: "2020-06-18 12:00:00",
    endTime: "2020-06-18 12:05:00",
    dynamic: true,
    duration: 10
  };
  const style__67 = {
    display: 'block',
    width: couponStyle__67.widthStyle === 'percentage' ? couponStyle__67.width + '%' : couponStyle__67.width,
    position: couponStyle__67.absolute ? 'absolute' : 'relative'
  };
  const timeController__68 = {
    startTime: "2020-06-18 12:05:01",
    endTime: "2020-06-18 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__69 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_40a458d095e245e69824ee08b8135611.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__69 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__70 = {
    startTime: "2020-06-19 00:00:00",
    endTime: "2020-06-19 11:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__71 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_9a56a225d81ee22e27482419a876a918.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__71 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__72 = {
    startTime: "2020-06-19 12:00:00",
    endTime: "2020-06-19 12:05:00",
    dynamic: true,
    duration: 10
  };
  const style__73 = {
    display: 'block',
    width: couponStyle__73.widthStyle === 'percentage' ? couponStyle__73.width + '%' : couponStyle__73.width,
    position: couponStyle__73.absolute ? 'absolute' : 'relative'
  };
  const timeController__74 = {
    startTime: "2020-06-19 12:30:01",
    endTime: "2020-06-19 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__75 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1e47a7d2c18d871809722f25980c4833.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__75 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__76 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_a6d15e67b0649139266bf6a520a26a0a.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__76 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__77 = {
    startTime: "2020-06-12 17:02:31",
    endTime: "2020-06-17 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__78 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_e964e8f92808177f0ada406899d12ac9.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__78 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__79 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_aa9ae0e84c667e7ff572129d800c2fd8.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/306688",
    linkOutApp: "https://m.qingting.fm/vchannels/306688",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__79 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__80 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_7e752862b9f4f6d56215c586e9db86c2.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/326781",
    linkOutApp: "https://m.qingting.fm/vchannels/326781",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__80 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__81 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_f1175bcfeffdcdd4819a5eb4f5a1d604.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/284338",
    linkOutApp: "https://m.qingting.fm/vchannels/284338",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__81 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__82 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_3adc5e652b81dc55b1d7339c01f37204.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/354272",
    linkOutApp: "https://m.qingting.fm/vchannels/354272",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__82 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__83 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_6821deb2223451924329d181eaa749af.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/356992",
    linkOutApp: "https://m.qingting.fm/vchannels/356992",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__83 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__84 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_38dbac6c6bd0c5de368616f1889d2d00.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/277468",
    linkOutApp: "https://m.qingting.fm/vchannels/277468",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__84 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__85 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_cae83a2bad9bb112428f2fd1de04d4f1.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/337438",
    linkOutApp: "https://m.qingting.fm/vchannels/337438",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__85 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__86 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_19ab2522ad2fb054f0356d54c8227f8d.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__86 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__87 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__88 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_010b2ecb6674d0bd02129e4246d158d5.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128aaa1cd3c8c675f",
    linkOutApp: "https://novel.qingting.fm/novels/172128aaa1cd3c8c675f",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__88 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__89 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_20c00c33717008067984f392cfe3326b.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7d1d26m2speo",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7d1d26m2speo",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__89 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__90 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_59fd760b521d8ab5fe9c9b060a5ef309.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__90 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__91 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__92 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_a591be2f32a3ef39df95c9444f0f5826.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/268108",
    linkOutApp: "https://m.qingting.fm/vchannels/268108",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__92 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__93 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_99479fc119711ca0844f293d292afe88.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/282952",
    linkOutApp: "https://m.qingting.fm/vchannels/282952",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__93 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__94 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_6d0e597e31f85125ab034b5e3e1ec8c6.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/265373",
    linkOutApp: "https://m.qingting.fm/vchannels/265373",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__94 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__95 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__96 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_ca1b702ac5e3615318bdc710f6ca4bf3.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/236126",
    linkOutApp: "https://m.qingting.fm/vchannels/236126",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__96 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__97 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1cfd46557895c5bdd40c485c127e4606.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/262788",
    linkOutApp: "https://m.qingting.fm/vchannels/262788",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__97 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__98 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_9a946c5e33bb3f9c460809e1ae39bdf9.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/327015",
    linkOutApp: "https://m.qingting.fm/vchannels/327015",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__98 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__99 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1e32322e49df3fd7d36619018e8f78a9.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__99 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const spaceLayoutConfig = {
    common: {
      height: 80,
      cloneElementId: ""
    },
    styles: {
      background: {
        color: "#8300dc",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      position: "relative",
      top: null
    }
  };
  const commonStyle = {
    backgroundImage: customStyle.bgImg ? `url(${customStyle.bgImg})` : customStyle.hasGradient ? `linear-gradient(${customStyle.gradientDeg}deg, ${customStyle.bgColor}, ${customStyle.bgColor2})` : 'none',
    backgroundSize: 'cover',
    backgroundColor: customStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle.zIndex,
    aspectRatio: customStyle.aspectRatio
  };
  const style__101 = {
    top: {
      height: customStyle.height + unit
    },
    bottom: {
      height: customStyle.height + unit
    },
    left: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    },
    right: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    }
  };
  const baseLayoutConfig__102 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: 0.3,
      bottom: null,
      left: 5.5,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__103 = {
    backgroundImage: `url(${btnStyle__103.bgImg})`,
    backgroundColor: btnStyle__103.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__103.color,
    fontSize: text__103.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__103.width + unit,
    height: btnStyle__103.height + unit,
    lineHeight: btnStyle__103.height + unit,
    borderRadius: btnStyle__103.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__103 = {
    top: position__103.top + unit,
    left: position__103.left + unit,
    right: position__103.right + unit,
    bottom: position__103.bottom + unit
  };
  const reStyle__103 = {
    marginTop: position__103.top + unit,
    marginBottom: position__103.bottom + unit,
    marginLeft: position__103.left + unit,
    marginRight: position__103.right + unit
  };
  const timeController__104 = {
    startTime: "2020-06-18 00:00:00",
    endTime: "2020-06-19 23:59:59",
    dynamic: true,
    duration: 10
  };
  const singleImage__105 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_110a8a0770b895537ca844219dbbc721.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__105 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__106 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_756ff112d0a2fc2e148dcbcbb0e0e0ff.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/359961",
    linkOutApp: "https://m.qingting.fm/vchannels/359961",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__106 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__107 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_452aa88da8a036384faf6dc0a367d3d7.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/292212",
    linkOutApp: "https://m.qingting.fm/vchannels/292212",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__107 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__108 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_12c5ee8b516733af78ddd71e7ad51ea3.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__108 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__109 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_f60d5200e3e6811382165a20f3618f43.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/306688",
    linkOutApp: "https://m.qingting.fm/vchannels/306688",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__109 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__110 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_60ac2a3d2b6fef58f8c8f8c836a9e716.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/326781",
    linkOutApp: "https://m.qingting.fm/vchannels/326781",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__110 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__111 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_e3e026c0b5952c72c1b62e3da82b273f.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/284338",
    linkOutApp: "https://m.qingting.fm/vchannels/284338",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__111 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__112 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b07fba6d37347051f444b20dc501d8b3.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/354272",
    linkOutApp: "https://m.qingting.fm/vchannels/354272",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__112 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__113 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_7d247350cf14fada2388df4ceee7c2e5.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/356992",
    linkOutApp: "https://m.qingting.fm/vchannels/356992",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__113 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__114 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_37eda629acca3089ca6aa685027e848f.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/277468",
    linkOutApp: "https://m.qingting.fm/vchannels/277468",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__114 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__115 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1ca683d4da827e9a11de44a53efe91b8.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/337438",
    linkOutApp: "https://m.qingting.fm/vchannels/337438",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__115 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__116 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_75dfd91b1059066c84b4a26dc342dfcf.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__116 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__117 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__118 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_3d3bd84b2bf11d1a11d3ad2e243858f8.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128aaa1cd3c8c675f",
    linkOutApp: "https://novel.qingting.fm/novels/172128aaa1cd3c8c675f",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__118 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__119 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_4a16ad88f91d0ef11c6bc742b9dc7c9b.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7d1d26m2speo",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7d1d26m2speo",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__119 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__120 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_039bd4c20ac5a134b22244d1c306c4de.jpg",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__120 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__121 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__122 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_b0ef9777f0d7d2de0204d0b7ebc24b16.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/268108",
    linkOutApp: "https://m.qingting.fm/vchannels/268108",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__122 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__123 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c45ce7800647c3ce20a3f1b0e187ff89.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/282952",
    linkOutApp: "https://m.qingting.fm/vchannels/282952",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__123 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__124 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_68333686f148821b733e35b0ac256719.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/265373",
    linkOutApp: "https://m.qingting.fm/vchannels/265373",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__124 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__125 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__126 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_138451f8a72a007147036f1f37f00152.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/236126",
    linkOutApp: "https://m.qingting.fm/vchannels/236126",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__126 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__127 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_17827339e78a3c0cd480d5408eca1bee.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/262788",
    linkOutApp: "https://m.qingting.fm/vchannels/262788",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__127 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__128 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_67fc4c4315613946cff24e3b89d6b308.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/327015",
    linkOutApp: "https://m.qingting.fm/vchannels/327015",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__128 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__129 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_0560a6605fd07654c37487ed128e5106.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__129 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const spaceLayoutConfig__130 = {
    common: {
      height: 80,
      cloneElementId: ""
    },
    styles: {
      background: {
        color: "#ff3048",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      position: "relative",
      top: null
    }
  };
  const commonStyle__131 = {
    backgroundImage: customStyle__131.bgImg ? `url(${customStyle__131.bgImg})` : customStyle__131.hasGradient ? `linear-gradient(${customStyle__131.gradientDeg}deg, ${customStyle__131.bgColor}, ${customStyle__131.bgColor2})` : 'none',
    backgroundSize: 'cover',
    backgroundColor: customStyle__131.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle__131.zIndex,
    aspectRatio: customStyle__131.aspectRatio
  };
  const style__131 = {
    top: {
      height: customStyle__131.height + unit
    },
    bottom: {
      height: customStyle__131.height + unit
    },
    left: {
      top: customStyle__131.top + unit,
      width: customStyle__131.width + unit,
      height: customStyle__131.height + unit
    },
    right: {
      top: customStyle__131.top + unit,
      width: customStyle__131.width + unit,
      height: customStyle__131.height + unit
    }
  };
  const baseLayoutConfig__132 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: 0.3,
      bottom: null,
      left: 5.5,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__133 = {
    backgroundImage: `url(${btnStyle__133.bgImg})`,
    backgroundColor: btnStyle__133.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__133.color,
    fontSize: text__133.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__133.width + unit,
    height: btnStyle__133.height + unit,
    lineHeight: btnStyle__133.height + unit,
    borderRadius: btnStyle__133.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__133 = {
    top: position__133.top + unit,
    left: position__133.left + unit,
    right: position__133.right + unit,
    bottom: position__133.bottom + unit
  };
  const reStyle__133 = {
    marginTop: position__133.top + unit,
    marginBottom: position__133.bottom + unit,
    marginLeft: position__133.left + unit,
    marginRight: position__133.right + unit
  };
  return <ContainerRender id="c6b" nodeId="968ce85f-e2ce-4284-b37b-0d2460c36c6b" nodeType="component-container" containerConfig={containerConfig} basicConfig={basicConfig}><TimeController id="3af" nodeId="668ce67e-03a3-4ddb-abd9-40fa1045c3af" nodeType="time-controller" config={timeController}><SingleImage id="b86" nodeId="95b8b388-7311-4ab8-8bb0-217c3d9ebb86" nodeType="image" config={singleImage} containerStyle={imageContainerStyle}><RenderRule id="d06" nodeId="44b820a7-e003-4174-bacf-8c97be2ced06" nodeType="fixed-rule" basicConfig={basicConfig__3}></RenderRule></SingleImage><SingleImage id="fd0" nodeId="c605163c-e299-43d2-8dab-664080f8cfd0" nodeType="image" config={singleImage__4} containerStyle={imageContainerStyle__4}><BaseLayout id="167" nodeId="c8281145-d684-42ee-8859-e4e12274f167" nodeType="base-layout" config={baseLayoutConfig}><BuyButton id="50e" nodeId="f08255b5-e35e-481c-9e70-6c5b3283750e" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style, abStyle) : Object.assign(style, reStyle)} text={text.content} popLog={popLog}></BuyButton></BaseLayout></SingleImage><SingleImage id="28f" nodeId="067c9316-97f7-43fd-bf93-63133eb4828f" nodeType="image" config={singleImage__7} containerStyle={imageContainerStyle__7}></SingleImage><SingleImage id="d53" nodeId="f2bdd0be-51bf-4f44-b0fd-9e82220f1d53" nodeType="image" config={singleImage__8} containerStyle={imageContainerStyle__8}></SingleImage><SingleImage id="f2d" nodeId="a9640076-00dc-4e24-8733-f4cd26c71f2d" nodeType="image" config={singleImage__9} containerStyle={imageContainerStyle__9}></SingleImage><SingleImage id="5ff" nodeId="ee1d124c-b09c-4759-a49d-3a63cca7b5ff" nodeType="image" config={singleImage__10} containerStyle={imageContainerStyle__10}></SingleImage><MemberDraw id="8c8" nodeId="7d3206a0-9b37-494d-8756-51fd6c77d8c8" nodeType="rotary-draw" {...config} threeParty={{
        jscookie,
        linkedme: window.linkedme,
        LotteryGrid,
        Toast,
        Modal,
        qtWebLog,
        qt,
        wxShare
      }}></MemberDraw><SingleImage id="e78" nodeId="fdf1dd77-cc33-4f96-b532-631861b12e78" nodeType="image" config={singleImage__12} containerStyle={imageContainerStyle__12}></SingleImage><SingleImage id="e52" nodeId="8dcd9554-c143-4951-8395-6ad642166e52" nodeType="image" config={singleImage__13} containerStyle={imageContainerStyle__13}></SingleImage><SingleImage id="0d7" nodeId="adff99e7-d2d0-4495-a94f-947de3ad40d7" nodeType="image" config={singleImage__14} containerStyle={imageContainerStyle__14}></SingleImage><HorizontalLayout id="705" nodeId="f93ecb99-516d-4321-b4d9-7b807961c705" nodeType="horizontal-layout" config={layoutConfig}><SingleImage id="c2a" nodeId="e61b78e4-d561-4b4d-a91f-dd607b23ec2a" nodeType="image" config={singleImage__16} containerStyle={imageContainerStyle__16}></SingleImage><SingleImage id="0e9" nodeId="f52c6cd6-87b1-47c1-864d-b6b5f67380e9" nodeType="image" config={singleImage__17} containerStyle={imageContainerStyle__17}></SingleImage><SingleImage id="990" nodeId="efde9c97-138b-4f43-a090-644a8e380990" nodeType="image" config={singleImage__18} containerStyle={imageContainerStyle__18}></SingleImage></HorizontalLayout><HorizontalLayout id="bed" nodeId="a8d79a4a-85aa-4436-8fd7-bb9f3cb85bed" nodeType="horizontal-layout" config={layoutConfig__19}><SingleImage id="ac3" nodeId="32448f54-9bb3-47b8-aee3-3ddcd579eac3" nodeType="image" config={singleImage__20} containerStyle={imageContainerStyle__20}></SingleImage><SingleImage id="48a" nodeId="656605a4-ff71-411c-a4a7-d834db79748a" nodeType="image" config={singleImage__21} containerStyle={imageContainerStyle__21}></SingleImage><SingleImage id="3f0" nodeId="70b2a0cb-bcb3-43e3-8f0d-3b67c132a3f0" nodeType="image" config={singleImage__22} containerStyle={imageContainerStyle__22}></SingleImage></HorizontalLayout><HorizontalLayout id="dbe" nodeId="1dca8b2b-1ff0-48de-8437-6bd6b6a34dbe" nodeType="horizontal-layout" config={layoutConfig__23}><SingleImage id="683" nodeId="ad1459c0-3b21-4b65-a158-2394946f3683" nodeType="image" config={singleImage__24} containerStyle={imageContainerStyle__24}></SingleImage><SingleImage id="7cd" nodeId="7c381aaa-8980-4f61-bdbe-37b2ec0f67cd" nodeType="image" config={singleImage__25} containerStyle={imageContainerStyle__25}></SingleImage><SingleImage id="969" nodeId="9991fbc6-e49c-40b3-a94d-823a52865969" nodeType="image" config={singleImage__26} containerStyle={imageContainerStyle__26}></SingleImage></HorizontalLayout><SingleImage id="b22" nodeId="e1c44eb7-23fd-4ed7-b240-368e461bfb22" nodeType="image" config={singleImage__27} containerStyle={imageContainerStyle__27}></SingleImage></TimeController><TimeController id="236" nodeId="e2516a9d-4ba7-4d5e-b80b-ffdb5a1e7236" nodeType="time-controller" config={timeController__28}><SingleImage id="1a0" nodeId="3a1742b9-9977-4e7f-b7e0-98ab4d3f31a0" nodeType="image" config={singleImage__29} containerStyle={imageContainerStyle__29}><RenderRule__30 id="8ba" nodeId="19055716-9d9f-4df9-84f2-be988ed7e8ba" nodeType="fixed-rule" basicConfig={basicConfig__30}></RenderRule__30></SingleImage><SingleImage id="bec" nodeId="bf5031a2-7815-4752-b872-209696bc8bec" nodeType="image" config={singleImage__31} containerStyle={imageContainerStyle__31}><RenderCountDown id="a86" nodeId="650ae709-63e1-4e45-9490-f6f5fc2cda86" nodeType="countdown" basicConfig={basicConfig__32}></RenderCountDown><BaseLayout id="f28" nodeId="6ac139d6-e845-4c7f-86d0-deaacdc9af28" nodeType="base-layout" config={baseLayoutConfig__33}><BuyButton__34 id="d4c" nodeId="d96c55ac-b5de-451d-abdf-9329836d4d4c" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__34, abStyle__34) : Object.assign(style__34, reStyle__34)} text={text__34.content} popLog={popLog}></BuyButton__34></BaseLayout></SingleImage><SingleImage id="992" nodeId="97a672aa-513e-4667-80c4-219820814992" nodeType="image" config={singleImage__35} containerStyle={imageContainerStyle__35}></SingleImage><SingleImage id="beb" nodeId="1d17ae18-f968-4a98-a9fd-27785feb7beb" nodeType="image" config={singleImage__36} containerStyle={imageContainerStyle__36}></SingleImage><SingleImage id="049" nodeId="e988d5f7-e75f-461f-b09b-7ef514d11049" nodeType="image" config={singleImage__37} containerStyle={imageContainerStyle__37}></SingleImage><SingleImage id="54a" nodeId="e1700449-ad30-4164-88e0-5378197ac54a" nodeType="image" config={singleImage__38} containerStyle={imageContainerStyle__38}></SingleImage><SingleImage id="ea1" nodeId="f2116702-f5a4-4e32-a93a-cfd5b23c2ea1" nodeType="image" config={singleImage__39} containerStyle={imageContainerStyle__39}></SingleImage><MemberDraw id="abd" nodeId="c74ecdf2-e0f0-4e13-b2e3-c093026e6abd" nodeType="rotary-draw" {...config__40} threeParty={{
        jscookie,
        linkedme: window.linkedme,
        LotteryGrid,
        Toast,
        Modal,
        qtWebLog,
        qt,
        wxShare
      }}></MemberDraw><SingleImage id="0c4" nodeId="99743962-351e-4421-8521-9222142ad0c4" nodeType="image" config={singleImage__41} containerStyle={imageContainerStyle__41}></SingleImage><SingleImage id="3a8" nodeId="60763e60-c6fd-4b44-95de-0943d89f93a8" nodeType="image" config={singleImage__42} containerStyle={imageContainerStyle__42}></SingleImage><SingleImage id="a76" nodeId="b85385bd-8cbc-4916-816c-8a08ee5d0a76" nodeType="image" config={singleImage__43} containerStyle={imageContainerStyle__43}></SingleImage><HorizontalLayout id="45a" nodeId="11e62d1a-0d4a-46de-af42-663bf647b45a" nodeType="horizontal-layout" config={layoutConfig__44}><SingleImage id="0d2" nodeId="7e8461c9-49ea-433e-819f-2f7128a810d2" nodeType="image" config={singleImage__45} containerStyle={imageContainerStyle__45}></SingleImage><SingleImage id="b65" nodeId="368dce23-2ac1-449a-8af1-302848392b65" nodeType="image" config={singleImage__46} containerStyle={imageContainerStyle__46}></SingleImage><SingleImage id="62c" nodeId="99fbd7a9-778a-449e-96e0-2233e7c7262c" nodeType="image" config={singleImage__47} containerStyle={imageContainerStyle__47}></SingleImage></HorizontalLayout><HorizontalLayout id="00b" nodeId="66e0cdbd-d076-49db-a601-b4110fbcb00b" nodeType="horizontal-layout" config={layoutConfig__48}><SingleImage id="798" nodeId="8fbe61e3-7587-4ecc-8ed9-ac95a7f45798" nodeType="image" config={singleImage__49} containerStyle={imageContainerStyle__49}></SingleImage><SingleImage id="93f" nodeId="56ac2c4f-dd3c-479b-aafe-c72bda4b693f" nodeType="image" config={singleImage__50} containerStyle={imageContainerStyle__50}></SingleImage><SingleImage id="b9c" nodeId="11338a1c-b768-46a3-8ab7-24cf58af1b9c" nodeType="image" config={singleImage__51} containerStyle={imageContainerStyle__51}></SingleImage></HorizontalLayout><HorizontalLayout id="e83" nodeId="7f2eb87d-0b19-4bb3-9501-6c9424041e83" nodeType="horizontal-layout" config={layoutConfig__52}><SingleImage id="c25" nodeId="b73024d6-7e2a-4cba-838d-28cf44ff8c25" nodeType="image" config={singleImage__53} containerStyle={imageContainerStyle__53}></SingleImage><SingleImage id="098" nodeId="4005dd18-0bad-4762-a632-050aad987098" nodeType="image" config={singleImage__54} containerStyle={imageContainerStyle__54}></SingleImage><SingleImage id="a09" nodeId="b877862b-b5d0-44f8-aa61-40e128539a09" nodeType="image" config={singleImage__55} containerStyle={imageContainerStyle__55}></SingleImage></HorizontalLayout><SingleImage id="fb5" nodeId="08957c63-3c51-4400-aa97-dd23adadafb5" nodeType="image" config={singleImage__56} containerStyle={imageContainerStyle__56}></SingleImage></TimeController><RenderReserve id="25a" nodeId="1895a084-7df7-4709-8d73-2c503651a25a" nodeType="reserve" styleConfig={styleConfig} basicConfig={basicConfig__57}></RenderReserve><TimeController id="b44" nodeId="309b1570-6c46-497a-ae23-6aff36ec3b44" nodeType="time-controller" config={timeController__58}><SingleImage id="8f0" nodeId="5137eeab-02f4-4039-addd-425153a1c8f0" nodeType="image" config={singleImage__59} containerStyle={imageContainerStyle__59}></SingleImage></TimeController><TimeController id="8b4" nodeId="7606dc94-d0f3-4e0a-98e0-a807d1c7b8b4" nodeType="time-controller" config={timeController__60}><Coupon id="653" nodeId="a5b6b250-cff4-4e84-a9cd-0cdb994d3653" nodeType="topic-coupon" imgSrc={couponImg} hasReceiveImg={hasReceiveImg} style={style__61} useCode={code} limitNum={limit}></Coupon></TimeController><TimeController id="001" nodeId="c546b6d7-18b5-44b4-80a8-82a25d0ef001" nodeType="time-controller" config={timeController__62}><SingleImage id="fb2" nodeId="999bbd3a-d40f-4922-9f00-bbeacd736fb2" nodeType="image" config={singleImage__63} containerStyle={imageContainerStyle__63}></SingleImage></TimeController><TimeController id="a22" nodeId="1851d00f-b796-47c0-96b1-d45e17554a22" nodeType="time-controller" config={timeController__64}><SingleImage id="0ef" nodeId="926a7da3-c962-4a71-9baf-a0ed468f30ef" nodeType="image" config={singleImage__65} containerStyle={imageContainerStyle__65}></SingleImage></TimeController><TimeController id="8df" nodeId="c5c47290-4631-4b0c-9a33-2965cd6148df" nodeType="time-controller" config={timeController__66}><Coupon__67 id="36f" nodeId="2a5b0af6-a9f0-4fec-939d-81339863436f" nodeType="topic-coupon" imgSrc={couponImg__67} hasReceiveImg={hasReceiveImg__67} style={style__67} useCode={code} limitNum={limit__67}></Coupon__67></TimeController><TimeController id="753" nodeId="41461dba-4adf-4b4e-a3a4-bb9cfcd00753" nodeType="time-controller" config={timeController__68}><SingleImage id="798" nodeId="eff68a8f-9832-4650-860e-051ca4e6d798" nodeType="image" config={singleImage__69} containerStyle={imageContainerStyle__69}></SingleImage></TimeController><TimeController id="2a9" nodeId="b7b26f8a-c46c-46b7-b5d6-aea5df3d02a9" nodeType="time-controller" config={timeController__70}><SingleImage id="b91" nodeId="9851de17-fded-425c-aea2-2fcb49a00b91" nodeType="image" config={singleImage__71} containerStyle={imageContainerStyle__71}></SingleImage></TimeController><TimeController id="65c" nodeId="2db6c0a9-6efb-47e1-aa2c-876caed4065c" nodeType="time-controller" config={timeController__72}><Coupon__73 id="940" nodeId="519a8d5e-1040-4ee3-b55e-c92163cc9940" nodeType="topic-coupon" imgSrc={couponImg__73} hasReceiveImg={hasReceiveImg__73} style={style__73} useCode={code} limitNum={limit__73}></Coupon__73></TimeController><TimeController id="3e4" nodeId="1e7f8b01-6fbd-4b9e-aad8-e562c8c3e3e4" nodeType="time-controller" config={timeController__74}><SingleImage id="d05" nodeId="1ca325be-0313-4dce-ab94-e67f41be8d05" nodeType="image" config={singleImage__75} containerStyle={imageContainerStyle__75}></SingleImage></TimeController><SingleImage id="8b9" nodeId="0c0cb977-8a33-4922-b383-094a283768b9" nodeType="image" config={singleImage__76} containerStyle={imageContainerStyle__76}></SingleImage><TimeController id="027" nodeId="2b7b487e-2c77-43bf-84b4-47bf209f4027" nodeType="time-controller" config={timeController__77}><SingleImage id="65c" nodeId="dcfd5828-7e92-47ed-be21-4eabfe3d365c" nodeType="image" config={singleImage__78} containerStyle={imageContainerStyle__78}></SingleImage><SingleImage id="840" nodeId="77b4b6cf-883a-4ad7-998c-03abd35ca840" nodeType="image" config={singleImage__79} containerStyle={imageContainerStyle__79}></SingleImage><SingleImage id="47b" nodeId="0b0f523b-805b-404e-a948-a789fa16047b" nodeType="image" config={singleImage__80} containerStyle={imageContainerStyle__80}></SingleImage><SingleImage id="51f" nodeId="07288f95-d0ad-4b6d-b578-a97521f9651f" nodeType="image" config={singleImage__81} containerStyle={imageContainerStyle__81}></SingleImage><SingleImage id="54e" nodeId="c259964f-ae88-40ab-a016-fc78826c854e" nodeType="image" config={singleImage__82} containerStyle={imageContainerStyle__82}></SingleImage><SingleImage id="7a1" nodeId="748e47d1-f728-4390-afab-41a3d0ad47a1" nodeType="image" config={singleImage__83} containerStyle={imageContainerStyle__83}></SingleImage><SingleImage id="8ef" nodeId="e3b6d1fe-bf57-438a-931a-5b8c2ea998ef" nodeType="image" config={singleImage__84} containerStyle={imageContainerStyle__84}></SingleImage><SingleImage id="920" nodeId="40447269-55cc-4ee1-8819-6ec93998d920" nodeType="image" config={singleImage__85} containerStyle={imageContainerStyle__85}></SingleImage><SingleImage id="792" nodeId="1df0ddb3-22f4-4a64-82c8-de52414ae792" nodeType="image" config={singleImage__86} containerStyle={imageContainerStyle__86}></SingleImage><HorizontalLayout id="edd" nodeId="42b734bc-de3d-42fc-8f33-02dc1920aedd" nodeType="horizontal-layout" config={layoutConfig__87}><SingleImage id="e96" nodeId="1d13ecca-2683-47ac-b027-e062ef510e96" nodeType="image" config={singleImage__88} containerStyle={imageContainerStyle__88}></SingleImage><SingleImage id="e45" nodeId="cfcaea4b-4571-4676-8dec-b18f99fa4e45" nodeType="image" config={singleImage__89} containerStyle={imageContainerStyle__89}></SingleImage><SingleImage id="aa5" nodeId="7bbb8718-b554-4c72-a735-e8712cfa2aa5" nodeType="image" config={singleImage__90} containerStyle={imageContainerStyle__90}></SingleImage></HorizontalLayout><HorizontalLayout id="ca0" nodeId="0a19eedd-f015-48ee-9eac-dcfcef362ca0" nodeType="horizontal-layout" config={layoutConfig__91}><SingleImage id="e04" nodeId="992f75c0-9985-413a-a4be-a7e79d23de04" nodeType="image" config={singleImage__92} containerStyle={imageContainerStyle__92}></SingleImage><SingleImage id="477" nodeId="74326ee5-5b84-45c9-8c74-c0a5d5ce7477" nodeType="image" config={singleImage__93} containerStyle={imageContainerStyle__93}></SingleImage><SingleImage id="64f" nodeId="37a2ca51-d1f5-4431-b91f-bc0f2837c64f" nodeType="image" config={singleImage__94} containerStyle={imageContainerStyle__94}></SingleImage></HorizontalLayout><HorizontalLayout id="cf2" nodeId="e6defc5d-5d2c-4fdc-9c3e-9ffcb8af4cf2" nodeType="horizontal-layout" config={layoutConfig__95}><SingleImage id="b87" nodeId="6a97ea98-a32b-4a0f-99a2-a6b93328eb87" nodeType="image" config={singleImage__96} containerStyle={imageContainerStyle__96}></SingleImage><SingleImage id="1cb" nodeId="9a33a969-d46c-4b74-a5a8-a16f200921cb" nodeType="image" config={singleImage__97} containerStyle={imageContainerStyle__97}></SingleImage><SingleImage id="bd8" nodeId="83839ff3-9bd4-4001-9eef-eee20b434bd8" nodeType="image" config={singleImage__98} containerStyle={imageContainerStyle__98}></SingleImage></HorizontalLayout><SingleImage id="f85" nodeId="62dc119a-a0eb-49bd-af24-d218dae99f85" nodeType="image" config={singleImage__99} containerStyle={imageContainerStyle__99}></SingleImage><SpaceLayout id="388" nodeId="2c2e4e20-3040-43d5-a2d9-1b4d75073388" nodeType="space-layout" config={spaceLayoutConfig}></SpaceLayout><FixedBar id="d07" nodeId="b21ba42c-d523-4b1c-a107-2349d40fcd07" nodeType="fixed-bar" position={position__101} customStyle={Object.assign(commonStyle, style__101[position])} effects={effects} effectParam={effectParam}><BaseLayout id="d8a" nodeId="429a51bb-8878-4e31-802c-bf8573e90d8a" nodeType="base-layout" config={baseLayoutConfig__102}><BuyButton__103 id="79a" nodeId="88ef3a45-b231-452e-9c9f-f03b5fd4879a" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__103, abStyle__103) : Object.assign(style__103, reStyle__103)} text={text__103.content} popLog={popLog__103}></BuyButton__103></BaseLayout></FixedBar></TimeController><TimeController id="643" nodeId="ed5f8eb8-dcfa-45a9-8512-57c406ee5643" nodeType="time-controller" config={timeController__104}><SingleImage id="7fd" nodeId="cea9f41e-5fae-4421-995f-6cbb9b63f7fd" nodeType="image" config={singleImage__105} containerStyle={imageContainerStyle__105}></SingleImage><SingleImage id="f0a" nodeId="71af5d15-d6ce-4b30-9bb7-30523e1c5f0a" nodeType="image" config={singleImage__106} containerStyle={imageContainerStyle__106}></SingleImage><SingleImage id="633" nodeId="92172ce5-07a1-405c-868e-a96da30c4633" nodeType="image" config={singleImage__107} containerStyle={imageContainerStyle__107}></SingleImage><SingleImage id="992" nodeId="1213f8e8-ec4e-4ad0-9e10-0508745b6992" nodeType="image" config={singleImage__108} containerStyle={imageContainerStyle__108}></SingleImage><SingleImage id="368" nodeId="520122cc-bfe6-4480-b303-3b7ebe2ae368" nodeType="image" config={singleImage__109} containerStyle={imageContainerStyle__109}></SingleImage><SingleImage id="06e" nodeId="a0d8db39-8095-45c3-82fd-79fcb2c0f06e" nodeType="image" config={singleImage__110} containerStyle={imageContainerStyle__110}></SingleImage><SingleImage id="c0d" nodeId="a128c5e1-e8f0-4f8f-9851-dcd7cf4dec0d" nodeType="image" config={singleImage__111} containerStyle={imageContainerStyle__111}></SingleImage><SingleImage id="01b" nodeId="69348dcd-b498-4f74-b979-9963b5ceb01b" nodeType="image" config={singleImage__112} containerStyle={imageContainerStyle__112}></SingleImage><SingleImage id="bc4" nodeId="0d7e0080-23e0-4e81-baf4-17b89d868bc4" nodeType="image" config={singleImage__113} containerStyle={imageContainerStyle__113}></SingleImage><SingleImage id="efa" nodeId="d69da154-f132-4105-9226-43c426011efa" nodeType="image" config={singleImage__114} containerStyle={imageContainerStyle__114}></SingleImage><SingleImage id="e81" nodeId="44069b54-5ab5-40e6-919a-ac712d9eae81" nodeType="image" config={singleImage__115} containerStyle={imageContainerStyle__115}></SingleImage><SingleImage id="8e2" nodeId="98a9c63b-e5e6-4321-88f1-24e084dbb8e2" nodeType="image" config={singleImage__116} containerStyle={imageContainerStyle__116}></SingleImage><HorizontalLayout id="8d8" nodeId="c667577d-0597-4e7e-8c6e-e775adc238d8" nodeType="horizontal-layout" config={layoutConfig__117}><SingleImage id="c29" nodeId="080497ea-d8d3-4911-90d6-bcfe70cf1c29" nodeType="image" config={singleImage__118} containerStyle={imageContainerStyle__118}></SingleImage><SingleImage id="633" nodeId="dfb6b048-20cc-49e7-b72f-cb09743c5633" nodeType="image" config={singleImage__119} containerStyle={imageContainerStyle__119}></SingleImage><SingleImage id="18e" nodeId="aed21e89-dba5-4fec-a8a2-624f1335418e" nodeType="image" config={singleImage__120} containerStyle={imageContainerStyle__120}></SingleImage></HorizontalLayout><HorizontalLayout id="c9b" nodeId="dc007489-8947-4bc8-8ca7-34124e82bc9b" nodeType="horizontal-layout" config={layoutConfig__121}><SingleImage id="335" nodeId="62e4d2a5-853d-456e-8b5c-4d4784bda335" nodeType="image" config={singleImage__122} containerStyle={imageContainerStyle__122}></SingleImage><SingleImage id="4ea" nodeId="78e011a1-a421-4ff6-84df-067ea1ba94ea" nodeType="image" config={singleImage__123} containerStyle={imageContainerStyle__123}></SingleImage><SingleImage id="753" nodeId="5f2d46b1-8445-4941-93a0-9610cb0a1753" nodeType="image" config={singleImage__124} containerStyle={imageContainerStyle__124}></SingleImage></HorizontalLayout><HorizontalLayout id="607" nodeId="d4767ca4-b71e-4ad2-90b3-5f9680ddf607" nodeType="horizontal-layout" config={layoutConfig__125}><SingleImage id="359" nodeId="59cb70c4-d75e-44d6-b95f-1b338c2af359" nodeType="image" config={singleImage__126} containerStyle={imageContainerStyle__126}></SingleImage><SingleImage id="d6c" nodeId="b45a2372-bfc4-40a8-b05d-945708844d6c" nodeType="image" config={singleImage__127} containerStyle={imageContainerStyle__127}></SingleImage><SingleImage id="c7f" nodeId="3e609da3-a8e8-4383-a050-08eeedcf0c7f" nodeType="image" config={singleImage__128} containerStyle={imageContainerStyle__128}></SingleImage></HorizontalLayout><SingleImage id="22b" nodeId="c6705b02-22b3-4379-b15e-f1366881b22b" nodeType="image" config={singleImage__129} containerStyle={imageContainerStyle__129}></SingleImage><SpaceLayout__130 id="6e5" nodeId="056d4913-f0d9-4efc-9335-8b543a0636e5" nodeType="space-layout" config={spaceLayoutConfig__130}></SpaceLayout__130><FixedBar__131 id="f1c" nodeId="9706b1c7-8bb7-4a60-b8e9-0156eaef5f1c" nodeType="fixed-bar" position={position__131} customStyle={Object.assign(commonStyle__131, style__131[position])} effects={effects} effectParam={effectParam__131}><BaseLayout id="32b" nodeId="e46518f2-f46a-4b04-824f-fc613220c32b" nodeType="base-layout" config={baseLayoutConfig__132}><BuyButton__133 id="054" nodeId="8e98662e-86b8-497a-9ffb-5a878c67d054" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__133, abStyle__133) : Object.assign(style__133, reStyle__133)} text={text__133.content} popLog={popLog}></BuyButton__133></BaseLayout></FixedBar__131></TimeController></ContainerRender>;
});